import React, { useEffect, useState, useContext } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { GlobalLoading, showLoading } from 'react-global-loading';
import BlockHeader from '../../../Components/Block/BlockHeader'
import { useLocation, useNavigate } from 'react-router-dom';
import { handleUserLevelAccessPermissions, validateRolesASI } from '../../../Custom/Custom';
import { getAuthHeaders, getUserClaimsForUi } from '../../../Constant';

import BlockA from '../../../Components/Block/BlockA';
import BlockB from '../../../Components/Block/BlockB';
import BlockC from '../../../Components/Block/BlockC';
import BlockD from '../../../Components/Block/BlockD';
import BlockE from '../../../Components/Block/BlockE';
import BlockF from '../../../Components/Block/BlockF';
import BlockG from '../../../Components/Block/BlockG';
import BlockH from '../../../Components/Block/BlockH';
import BlockI from '../../../Components/Block/BlockI';
import BlockJ from '../../../Components/Block/BlockJ';
import BlockK from '../../../Components/Block/BlockK';
import BlockL from '../../../Components/Block/BlockL';
import BlockM from '../../../Components/Block/BlockM';
import BlockN from '../../../Components/Block/BlockN';
import { BlockEContextData } from '../../../context/BlockEContext';



function Block() {
 const{initialData}=useContext(BlockEContextData)
  const location = useLocation();
  const pageName = location.pathname.substring(1);
  const [blockPageInfo, setBlockPageInfo] = useState({ blockName: '', blockHeading: '' })
  const [buttonAccess, setButtonAccess] = useState({ userLevel: '', roles: '', isVisible: false });
  const [accessBlockIds, setAccessBlockIds] = useState(JSON.parse(localStorage.getItem('blockIds')) ?? [1]);
  const blockE19WagesOrSalaries = initialData ?? null;
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  const config = getAuthHeaders();

  const blockInfo = JSON.parse(localStorage.getItem('blockInfo')) ?? { dslNo: '', surveyYear: '' };
  const statusUnitCode = String(localStorage.getItem('statusUnitCode') || '').trim();
  const isStatusUnitCode2 = statusUnitCode === '2';
  const isStatusUnitCode3 = statusUnitCode === '3';
  const isSurveyYear2024 = String(blockInfo?.surveyYear ?? '') === '2024';
  // Status 4/5/7/8 (2024): C,D,E,F,G,H,I,J,K stay disabled — only A→B→L→M→N
  const isStatusUnitCode4578 = ['4', '5', '7', '8'].includes(statusUnitCode) && isSurveyYear2024;

  // Status=2 flow: only A -> B -> C -> E -> L -> M -> N
  const STATUS2_SEQUENCE = [1, 2, 3, 5, 12, 13, 14];
  // Status=3 flow: only A -> B -> C -> L -> M -> N
  const STATUS3_SEQUENCE = [1, 2, 3, 12, 13, 14];
  // Status=4/5/7/8 flow: only A -> B -> L -> M -> N
  const STATUS4578_SEQUENCE = [1, 2, 12, 13, 14];

  const computeSequenceUnlockedIds = (ids, sequence) => {
    const set = new Set((ids || []).map(Number));
    const unlocked = [];
    for (const id of sequence) {
      unlocked.push(id);
      if (!set.has(id)) break;
    }
    return unlocked;
  };

  const computeStatus2UnlockedIds = (ids) => computeSequenceUnlockedIds(ids, STATUS2_SEQUENCE);

  const effectiveAccessBlockIds = React.useMemo(() => {
    if (isStatusUnitCode4578) return computeSequenceUnlockedIds(accessBlockIds, STATUS4578_SEQUENCE);
    if (isStatusUnitCode2) return computeStatus2UnlockedIds(accessBlockIds);
    if (isStatusUnitCode3) return computeSequenceUnlockedIds(accessBlockIds, STATUS3_SEQUENCE);
    return accessBlockIds;
  }, [accessBlockIds, isStatusUnitCode2, isStatusUnitCode3, isStatusUnitCode4578]);

  useEffect(() => {
    console.log(":::::::::::::::: block page initial data", initialData);
  }, [blockE19WagesOrSalaries]);

  useEffect(() => {
    fetchData();
  }, []);


  const fetchData = async () => {
    try {
      if (!decode_token?.id) {
        navigate('/dashboard');
        return;
      }
      const isAuthorized = await validateRolesASI(decode_token);

      if (!isAuthorized) {
        window.alert("You are not an authorized user to capture the data for ASI Block A");
        navigate("/dashboard");
        return;
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  

  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)

    const pageObject = (pageName) => {
      switch (pageName) {
        case "BlockA":
          return {
            blockName: "BlockA",
            blockHeading: "Block 'A': Identification particulars (For Office Use)",
          };
        case "BlockB":
          return {
            blockName: "BlockB",
            blockHeading: "Block 'B': Particulars of the factory (To be filled by the owner of the factory)"
          };
        case "BlockC":
          return {
            blockName: "BlockC",
            blockHeading: "Block 'C': Fixed Assets"
          };
        case "BlockD":
          return {
            blockName: "BlockD",
            blockHeading: "Block 'D': Working Capital and Loans"
          };
        case "BlockE":
          return {
            blockName: "BlockE",
            blockHeading: "Block 'E': Employement and Labour Cost"
          };
        case "BlockF":
          return {
            blockName: "BlockF",
            blockHeading: "Block 'F': Other Expenses"
          };
        case "BlockG":
          return {
            blockName: "BlockG",
            blockHeading: "Block 'G': Other Output/Receipts"
          };
        case "BlockH":
          return {
            blockName: "BlockH",
            blockHeading: "Block 'H': Indigenous input items consumed"
          };
        case "BlockI":
          return {
            blockName: "BlockI",
            blockHeading: "Block 'I': Imported input items consumed - directly only"
          };
        case "BlockJ":
          return {
            blockName: "BlockJ",
            blockHeading: "Block 'J': Products and By-Products manufactured by the unit"
          };
        case "BlockK":
          return {
            blockName: "BlockK",
            blockHeading: "Block 'K': Information and Communication Technology(ICT) USAGE"
          };
        case "BlockL":
          return {
            blockName: "BlockL",
            blockHeading: "Block 'L': Energy Conservation(EC) Measures"
          };
        case "BlockM":
          return {
            blockName: "BlockM",
            blockHeading: "Block 'M': Energy Conservation(EC) Measures"
          };
        case "BlockN":
          return {
            blockName: "BlockN",
            blockHeading: "Block 'N': Energy Conservation(EC) Measures"
          };
        default:
          return {
            blockName: "sss",
            blockHeading: "ttt"
          };
      }
    }

    const result = pageObject(pageName);
    setBlockPageInfo(result)

    // Check if user has access to the requested block
    const checkBlockAccess = () => {
      const blockIdMap = {
        'BlockA': 1,
        'BlockB': 2,
        'BlockC': 3,
        'BlockD': 4,
        'BlockE': 5,
        'BlockF': 6,
        'BlockG': 7,
        'BlockH': 8,
        'BlockI': 9,
        'BlockJ': 10,
        'BlockK': 11,
        'BlockL': 12,
        'BlockM': 13,
        'BlockN': 14
      };

      const requestedBlockId = blockIdMap[pageName];
      // Use freshest ids from storage to avoid redirect race after save->navigate
      const storedIdsRaw = JSON.parse(localStorage.getItem('blockIds'));
      const storedIds = Array.isArray(storedIdsRaw) && storedIdsRaw.length ? storedIdsRaw.map(Number) : accessBlockIds;
      const effectiveIdsForCheck = isStatusUnitCode4578
        ? computeSequenceUnlockedIds(storedIds, STATUS4578_SEQUENCE)
        : isStatusUnitCode2
        ? computeStatus2UnlockedIds(storedIds)
        : (isStatusUnitCode3
            ? computeSequenceUnlockedIds(storedIds, STATUS3_SEQUENCE)
            : storedIds);

      // Status=4/5/7/8: only allow A,B,L,M,N — C,D,E,F,G,H,I,J,K stay blocked
      if (isStatusUnitCode4578 && requestedBlockId) {
        if (!STATUS4578_SEQUENCE.includes(requestedBlockId) || !effectiveIdsForCheck.includes(requestedBlockId)) {
          const redirectId = effectiveIdsForCheck[effectiveIdsForCheck.length - 1] || 1;
          const redirectRoute = {
            1: '/BlockA', 2: '/BlockB', 12: '/BlockL', 13: '/BlockM', 14: '/BlockN'
          }[redirectId] || '/BlockA';
          navigate(redirectRoute);
          return;
        }
      } else if (isStatusUnitCode2 && requestedBlockId) {
        if (!STATUS2_SEQUENCE.includes(requestedBlockId) || !effectiveIdsForCheck.includes(requestedBlockId)) {
          const redirectId = effectiveIdsForCheck[effectiveIdsForCheck.length - 1] || 1;
          const redirectRoute = {
            1: '/BlockA', 2: '/BlockB', 3: '/BlockC', 12: '/BlockL', 13: '/BlockM', 14: '/BlockN'
          }[redirectId] || '/BlockA';
          navigate(redirectRoute);
          return;
        }
      } else if (isStatusUnitCode3 && requestedBlockId) {
        // Status=3: only allow sequence blocks, and only if unlocked
        if (!STATUS3_SEQUENCE.includes(requestedBlockId) || !effectiveIdsForCheck.includes(requestedBlockId)) {
          const redirectId = effectiveIdsForCheck[effectiveIdsForCheck.length - 1] || 1;
          const redirectRoute = {
            1: '/BlockA', 2: '/BlockB', 3: '/BlockC', 12: '/BlockL', 13: '/BlockM', 14: '/BlockN'
          }[redirectId] || '/BlockA';
          navigate(redirectRoute);
          return;
        }
      } else {
        // Default: If it's a valid block but user doesn't have access, navigate to BlockA
        if (requestedBlockId && !accessBlockIds.includes(requestedBlockId)) {
          console.log(`User doesn't have access to ${pageName}, redirecting to BlockA`);
          navigate('/BlockA');
          return;
        }
      }

      if (pageName === 'ASIComparision') {
        navigate('/BlockN', { replace: true });
        return;
      }

      // If it's an invalid block name, navigate to BlockA
      if (!requestedBlockId && pageName !== 'BlockA') {
        console.log(`Invalid block name: ${pageName}, redirecting to BlockA`);
        navigate('/BlockA');
        return;
      }
    };

    // Check block access after setting block info
    checkBlockAccess();

  }, [pageName, accessBlockIds, effectiveAccessBlockIds, isStatusUnitCode2, isStatusUnitCode3, isStatusUnitCode4578, navigate]);

  // Centralized navigation effect
  React.useEffect(() => {
    // Map blockId to route
    const blockIdToRoute = {
      1: '/BlockA',
      2: '/BlockB',
      3: '/BlockC',
      4: '/BlockD',
      5: '/BlockE',
      6: '/BlockF',
      7: '/BlockG',
      8: '/BlockH',
      9: '/BlockI',
      10: '/BlockJ',
      11: '/BlockK',
      12: '/BlockL',
      13: '/BlockM',
      14: '/BlockN'
    };
    // Get current blockId from path
    const currentBlockId = Object.entries(blockIdToRoute)
      .find(([id, route]) => route.toLowerCase() === location.pathname.toLowerCase())?.[0];
    // If current block is not accessible, navigate to the next accessible block
    // Use freshest ids from storage to avoid redirect race after save->navigate
    const storedIdsRaw = JSON.parse(localStorage.getItem('blockIds'));
    const storedIds = Array.isArray(storedIdsRaw) && storedIdsRaw.length ? storedIdsRaw.map(Number) : accessBlockIds;
    const activeIds = isStatusUnitCode4578
      ? computeSequenceUnlockedIds(storedIds, STATUS4578_SEQUENCE)
      : isStatusUnitCode2
      ? computeStatus2UnlockedIds(storedIds)
      : (isStatusUnitCode3
          ? computeSequenceUnlockedIds(storedIds, STATUS3_SEQUENCE)
          : storedIds);
    if (currentBlockId && !activeIds.includes(Number(currentBlockId))) {
      // Find the lowest accessible blockId
      const nextBlockId = Math.min(...activeIds);
      if (blockIdToRoute[nextBlockId] && location.pathname !== blockIdToRoute[nextBlockId]) {
        navigate(blockIdToRoute[nextBlockId]);
      }
    }
  }, [accessBlockIds, effectiveAccessBlockIds, isStatusUnitCode2, isStatusUnitCode3, isStatusUnitCode4578, location.pathname, navigate]);

  const accessAsiBlockFunction = (blockIdArray) => {
    let nextIds = Array.isArray(blockIdArray) ? blockIdArray.map(Number) : [];

    if (isStatusUnitCode4578) {
      // Keep only A,B,L,M,N — ignore C,D,E,F,G,H,I,J,K even if blockValidation returns them
      nextIds = Array.from(new Set(nextIds.filter((id) => STATUS4578_SEQUENCE.includes(id)))).sort((a, b) => a - b);
      if (!nextIds.includes(1)) nextIds.unshift(1);
    } else if (isStatusUnitCode2) {
      // Keep only status=2 blocks for "saved blocks" state; access (navigation) is controlled separately via effectiveAccessBlockIds
      nextIds = Array.from(new Set(nextIds.filter((id) => STATUS2_SEQUENCE.includes(id)))).sort((a, b) => a - b);
      if (!nextIds.includes(1)) nextIds.unshift(1);
    } else if (isStatusUnitCode3) {
      // Keep only status=3 blocks for "saved blocks" state; access (navigation) is controlled separately via effectiveAccessBlockIds
      nextIds = Array.from(new Set(nextIds.filter((id) => STATUS3_SEQUENCE.includes(id)))).sort((a, b) => a - b);
      if (!nextIds.includes(1)) nextIds.unshift(1);
    }

    localStorage.setItem('blockIds', JSON.stringify(nextIds));
    setAccessBlockIds(nextIds);

  }
  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        {blockPageInfo.blockName === "BlockA" &&
          <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
              <div className="row align-items-center">
                <p className="mb-0 px-3">
                  <a href="pdf/ASI_Data_Entry_User_Manual.pdf" target="new"
                    className="btn btn-sm btn_green me-2 mb-2">ASI Data Entry
                    User Manual <i className="fa fa-file-pdf-o ms-2"></i></a>

                  {/* <a href="pdf/ASI_Instruction_Manual_2021-22.pdf" target="new"
                    className="btn btn-sm btn_green me-2 mb-2">ASI
                    Instruction Manual 2021-22 <i className="fa fa-file-pdf-o ms-2"></i>
                    </a> */}

                  <a href="pdf/ASI_Instruction_Manual_2024-25.pdf" target="new"
                    className="btn btn-sm btn_green me-2 mb-2">ASI
                    Instruction Manual 2024-25 <i className="fa fa-file-pdf-o ms-2"></i></a>

                  <a href="pdf/Data_Capture_and_reporting_ ASI.pdf" target="new"
                    className="btn btn-sm btn_green me-2 mb-2">ASI_Schedule_Instruction <i
                      className="fa fa-file-pdf-o ms-2"></i></a>

                  <a href="pdf/ASI_schedule_2024-25.pdf" target="new"
                    className="btn btn-sm btn_green me-2 mb-2">ASI_Schedule_2024-25 <i
                      className="fa fa-file-pdf-o ms-2"></i></a>

                  <a href="pdf/ASI-Manual.mp4" target="new" className="btn btn-sm btn_green me-2 mb-2">ASI Video
                    Help <i className="fa fa-video-camera ms-2"></i></a>

                  <a href="pdf/NIC_2008.pdf" target="new" className="btn btn-sm btn_green me-2 mb-2">NIC 2008 <i
                    className="fa fa-file-pdf-o ms-2"></i></a>
                  <a href="pdf/NPCMS 2011- Revised.pdf" target="new" className="btn btn-sm btn_green me-2 mb-2">NPCMS
                    2011
                    <i className="fa fa-file-pdf-o ms-2"></i></a>
                </p>
              </div>
            </div>
          </div>
        }

        <BlockHeader
          blockPageInfo={blockPageInfo}
          accessBlockIds={effectiveAccessBlockIds}
          savedBlockIds={accessBlockIds}
          blockInfo={blockInfo}
        />
        {/*     
     {accessBlockIds.some(value => [1,2,3,4,5,6,7,8,9,10,11,12].includes(value)) ?
        
        'access'
      
        :

         <div className="card mx-3 mb-3">
          Block is not access
        </div>
     } */}
        <div className="card mx-3 mb-3">

          {(blockPageInfo.blockName === 'BlockA' && effectiveAccessBlockIds.includes(1)) && (
            <BlockA
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />
          )}


          {(blockPageInfo.blockName === 'BlockB' && effectiveAccessBlockIds.includes(2)) && (
            <BlockB
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}

            />)}

          {(blockPageInfo.blockName === 'BlockC' && effectiveAccessBlockIds.includes(3)) && (
            <BlockC
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}

          {(blockPageInfo.blockName === 'BlockD' && effectiveAccessBlockIds.includes(4)) && (
            <BlockD
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}

          {(blockPageInfo.blockName === 'BlockE' && effectiveAccessBlockIds.includes(5)) && (
            <BlockE
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
              setBlockE19WagesOrSalaries={() => {}} // No state setter to pass
            />)}

          {(blockPageInfo.blockName === 'BlockF' && effectiveAccessBlockIds.includes(6)) && (
            <BlockF
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}

          {(blockPageInfo.blockName === 'BlockG' && effectiveAccessBlockIds.includes(7)) && (
            <BlockG
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}

          {(blockPageInfo.blockName === 'BlockH' && effectiveAccessBlockIds.includes(8)) && (
            <BlockH
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}

          {(blockPageInfo.blockName === 'BlockI' && effectiveAccessBlockIds.includes(9)) && (
            <BlockI
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
              blockEfieldData={{ wagesOrSalaries: initialData !== null ? initialData : (blockE19WagesOrSalaries || 0) }}
            />)}

          {(blockPageInfo.blockName === 'BlockJ' && effectiveAccessBlockIds.includes(10)) && (
            <BlockJ
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}

          {(blockPageInfo.blockName === 'BlockK' && effectiveAccessBlockIds.includes(11)) && (
            <BlockK
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}

          {(blockPageInfo.blockName === 'BlockL' && effectiveAccessBlockIds.includes(12)) && (
            <BlockL
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}

          {(blockPageInfo.blockName === 'BlockM' && effectiveAccessBlockIds.includes(13)) && (
            <BlockM
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />)}


          {(blockPageInfo.blockName === 'BlockN' && effectiveAccessBlockIds.includes(14)) && (
            <BlockN
              blockPageInfo={blockPageInfo}
              config={config}
              userInfoObject={buttonAccess}
              blockInfo={blockInfo}
              accessAsiBlock={accessAsiBlockFunction}
              decode_token={decode_token}
            />
          )}


        </div>

      </div>



    </>
  )
}

export default Block